import {
  arbitrumApi,
  avalancheApi,
  binanceApi,
  ethereumApi,
  fantomApi,
  // gnosisApi,
  // optimismApi,
  polygonApi,
  // klaytnApi,
  // auroraApi,
} from '@yozh-io/1inch-widget-api-client';

import { NetworkConfig, SupportedChainId, SupportedChainIdInHex } from '../types';
import { ProtocolName } from './protocolNames';

/**
 * Array of all the supported chain IDs
 */
export const ALL_SUPPORTED_CHAIN_IDS = new Set(Object.values(SupportedChainId).filter((id) => typeof id === 'number'));

export const networkConfigs: Record<string, NetworkConfig> = {
  [SupportedChainId.MAINNET]: {
    chainName: 'Ethereum Mainnet',
    chainIdHex: SupportedChainIdInHex.MAINNET,
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
    },
    explorerName: 'EtherScan',
    blockExplorerUrls: ['https://etherscan.io'],
    helperContract: process.env.REACT_APP_HELPER_CONTRACT_ETHEREUM || '0x9E7a4300FBC63c59eC556E5F9962a125D369e42C',
    api: ethereumApi,
    minGasLimit: '200000',
    supportedProtocols: [ProtocolName.ONE_INCH],
  },
  [SupportedChainId.BINANCE]: {
    chainName: 'Binance Smart Chain Mainnet',
    chainIdHex: SupportedChainIdInHex.BINANCE,
    nativeCurrency: {
      name: 'Binance Chain Native Token',
      symbol: 'BNB',
      decimals: 18,
    },
    explorerName: 'BscScan',
    blockExplorerUrls: ['https://bscscan.com'],
    helperContract: process.env.REACT_APP_HELPER_CONTRACT_BNB || '0x9E7a4300FBC63c59eC556E5F9962a125D369e42C',
    api: binanceApi,
    minGasLimit: '275000',
    supportedProtocols: [ProtocolName.ONE_INCH],
  },
  [SupportedChainId.POLYGON]: {
    chainName: 'Polygon Mainnet',
    chainIdHex: SupportedChainIdInHex.POLYGON,
    nativeCurrency: {
      name: 'MATIC',
      symbol: 'MATIC',
      decimals: 18,
    },
    explorerName: 'PolygonScan',
    blockExplorerUrls: ['https://polygonscan.com'],
    helperContract: process.env.REACT_APP_HELPER_CONTRACT_POLYGON || '0x9E7a4300FBC63c59eC556E5F9962a125D369e42C',
    api: polygonApi,
    minGasLimit: '250000',
    supportedProtocols: [ProtocolName.ONE_INCH],
  },
  // [SupportedChainId.OPTIMISM]: {
  //   chainName: 'Optimism',
  //   chainIdHex: SupportedChainIdInHex.OPTIMISM,
  //   nativeCurrency: {
  //     name: 'Ether',
  //     symbol: 'ETH',
  //     decimals: 18,
  //   },
  //   explorerName: 'Optimism',
  //   blockExplorerUrls: ['https://optimistic.etherscan.io'],
  //   helperContract: process.env.REACT_APP_HELPER_CONTRACT_OPTIMISM || '',
  //   api: optimismApi,
  //   minGasLimit: '200000',
  //   supportedProtocols: [ProtocolName.ONE_INCH],
  // },

  [SupportedChainId.ARBITRUM_ONE]: {
    chainName: 'Arbitrum One',
    chainIdHex: SupportedChainIdInHex.ARBITRUM_ONE,
    nativeCurrency: {
      name: 'Ether',
      symbol: 'ETH',
      decimals: 18,
    },
    explorerName: 'ArbiScan',
    blockExplorerUrls: ['https://arbiscan.io'],
    helperContract: process.env.REACT_APP_HELPER_CONTRACT_ARBITRUM || '0x9E7a4300FBC63c59eC556E5F9962a125D369e42C',
    api: arbitrumApi,
    minGasLimit: '300000',
    supportedProtocols: [ProtocolName.ONE_INCH],
  },
  // [SupportedChainId.GNOSIS]: {
  //   chainName: 'Gnosis Chain',
  //   chainIdHex: SupportedChainIdInHex.GNOSIS,
  //   nativeCurrency: {
  //     name: 'xDAI',
  //     symbol: 'xDAI',
  //     decimals: 18,
  //   },
  //   explorerName: 'BlockScout',
  //   blockExplorerUrls: ['https://blockscout.com/xdai/mainnet'],
  //   helperContract: process.env.REACT_APP_HELPER_CONTRACT_GNOSIS || '',
  //   api: gnosisApi,
  //   minGasLimit: '200000',
  //   supportedProtocols: [ProtocolName.ONE_INCH],
  // },

  [SupportedChainId.AVALANCHE]: {
    chainName: 'Avalanche C-Chain',
    chainIdHex: SupportedChainIdInHex.AVALANCHE,
    nativeCurrency: {
      name: 'Avalanche',
      symbol: 'AVAX',
      decimals: 18,
    },
    explorerName: 'Snowtrace',
    blockExplorerUrls: ['https://snowtrace.io'],
    helperContract: process.env.REACT_APP_HELPER_CONTRACT_AVALANCHE || '0x9E7a4300FBC63c59eC556E5F9962a125D369e42C',
    api: avalancheApi,
    minGasLimit: '250000',
    supportedProtocols: [ProtocolName.ONE_INCH],
  },
  [SupportedChainId.FANTOM]: {
    chainName: 'Fantom Opera',
    chainIdHex: SupportedChainIdInHex.FANTOM,
    nativeCurrency: {
      name: 'Fantom',
      symbol: 'FTM',
      decimals: 18,
    },
    explorerName: 'FTMScan',
    blockExplorerUrls: ['https://ftmscan.com'],
    helperContract: process.env.REACT_APP_HELPER_CONTRACT_FANTOM || '0x9E7a4300FBC63c59eC556E5F9962a125D369e42C',
    api: fantomApi,
    minGasLimit: '275000',
    supportedProtocols: [ProtocolName.ONE_INCH],
  },
  // [SupportedChainId.KLAYTN]: {
  //   chainName: 'KLAYTN MAINNET',
  //   chainIdHex: SupportedChainIdInHex.KLAYTN,
  //   nativeCurrency: {
  //     name: 'Klaytn',
  //     symbol: 'KLAY',
  //     decimals: 18,
  //   },
  //   explorerName: 'KlaytnScope',
  //   blockExplorerUrls: ['https://scope.klaytn.com/'],
  //   helperContract: process.env.REACT_APP_HELPER_CONTRACT_KLAYTN|| '0x9E7a4300FBC63c59eC556E5F9962a125D369e42C',
  //   api: klaytnApi,
  //   minGasLimit: '200000',
  //   supportedProtocols: [ProtocolName.ONE_INCH],
  // },
  // [SupportedChainId.AURORA]: {
  //   chainName: 'AURORA MAINNET',
  //   chainIdHex: SupportedChainIdInHex.AURORA,
  //   nativeCurrency: {
  //     name: 'Aurora',
  //     symbol: 'AURORA',
  //     decimals: 18,
  //   },
  //   explorerName: 'AuroraExplorer',
  //   blockExplorerUrls: ['https://explorer.aurora.dev/'],
  //   helperContract: process.env.REACT_APP_HELPER_CONTRACT_AURORA || '0x9E7a4300FBC63c59eC556E5F9962a125D369e42C',
  //   api: auroraApi,
  //   minGasLimit: '200000',
  //   supportedProtocols: [ProtocolName.ONE_INCH],
  // },
};

/**
 * Returns networkConfigs depends on chainId
 * number | undefined -> returns networkConfigs | undefined
 */
export function getNetworkConfig(chainId: number | undefined): any {
  if (chainId) {
    return networkConfigs[chainId] ?? undefined;
  }
  return undefined;
}
